export default __webpack_public_path__ + "static/media/sentro-signup.f8308c6a.jpg";